var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 267",
    style: {
      fill: "transparent"
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1272",
    d: "M10.5 2.5a8 8 0 1 0 8 8 8.007 8.007 0 0 0-8-8zm-.876 3.655a1.149 1.149 0 0 1 .876-.387 1.182 1.182 0 0 1 1.179 1.179V7.1l-.606 4.884a2.139 2.139 0 0 0-.573-.084 2.092 2.092 0 0 0-.556.067l-.623-4.886a1.285 1.285 0 0 1 .303-.926zm.876 9.078a1.186 1.186 0 0 1-1.179-1.2 1.172 1.172 0 0 1 1.179-1.175 1.186 1.186 0 0 1 1.2 1.179 1.211 1.211 0 0 1-1.2 1.196z",
    transform: "translate(-.5 -.5)",
    style: {
      fill: "#a39d99"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.74f625babcf5904f4801eb070cdbf64f.svg";
export { ForwardRef as ReactComponent };